import { PersonVoice20Regular } from '@/components/Icon'
import ActionButtonRow from './ActionButtonRow'
import styles from './HomePrimaryActions.module.scss'

export default function HomeVoicePrimaryActions({ onNewRecording, newRecordingActive = false }) {
  return (
    <div className={styles.group}>
      <ActionButtonRow
        Icon={PersonVoice20Regular}
        label="New Recording"
        onClick={onNewRecording}
        active={newRecordingActive}
      />
    </div>
  )
}
